import QRCode from 'qrcode';

async function generateQrSvgDataUrl(url) {
    const svg = await QRCode.toString(url, { type: 'svg', margin: 0 });
    const encoded = encodeURIComponent(svg);
    return `data:image/svg+xml;utf8,${encoded}`;
  }

function openPrintWindow(html) {
  const w = window.open('', '_blank');
  w.document.write(html);
  w.document.close();
  w.focus();
  w.print();
}

function buildLabelsHtml(items, title = 'Ski Fleet - QR Labels') {
    return `<!doctype html>
  <html>
  <head>
    <meta charset="utf-8" />
    <title>${title}</title>
    <style>
      @page { size: A4; margin: 12mm; }
      body { font-family: Arial, sans-serif; margin: 0; padding: 12mm; }
      .grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12mm; }
      .label { border: 1px solid #ccc; padding: 6mm; text-align: center; border-radius: 4px; }
      .qr { border: 2px solid #000; display: inline-block; padding: 3mm; }
      .qr img { width: 22mm; height: 22mm; display: block; }
      .num { font-size: 16px; font-weight: 700; margin-top: 6px; }
      .logo { height: 18px; margin-top: 6px; opacity: 0.85; }
      .meta { font-size: 11px; color: #555; margin-top: 2px; }
  
      @media print {
        .label { page-break-inside: avoid; }
        body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      }
    </style>
  </head>
  <body>
    <div class="grid">
      ${items.map(it => `
        <div class="label">
          <div class="qr"><img src="${it.qr}" alt="QR" /></div>
          <div class="num">Ski #${it.ski_number} • ${it.brand}</div>
          <img class="logo" src="${it.logo}" alt="Ski Fleet" />
          <div class="meta">${it.type.toUpperCase()}</div>
        </div>
      `).join('')}
    </div>
  </body>
  </html>`;
  }

export async function printAllSkiQrLabels(skis, { origin = window.location.origin, logo = '/logo512.png' } = {}) {
  const items = [];
  for (const ski of skis) {
    if (!ski.qr_code) continue;
    const url = `${origin}/ski/${ski.qr_code}`;
    const qr = await generateQrSvgDataUrl(url);
    // two labels per pair
    items.push({ qr, ski_number: ski.ski_number, brand: ski.brand, type: ski.type, ski_length_cm: ski.ski_length_cm, logo });
    items.push({ qr, ski_number: ski.ski_number, brand: ski.brand, type: ski.type, ski_length_cm: ski.ski_length_cm, logo });
  }
  if (items.length === 0) return;
  openPrintWindow(buildLabelsHtml(items, 'Ski Fleet - All QR Labels'));
}

export async function printSingleSkiQrLabels(ski, { origin = window.location.origin, logo = '/logo512.png' } = {}) {
  if (!ski?.qr_code) return;
  const url = `${origin}/ski/${ski.qr_code}`;
  const qr = await generateQrSvgDataUrl(url);
  const items = [
    { qr, ski_number: ski.ski_number, brand: ski.brand, type: ski.type, ski_length_cm: ski.ski_length_cm, logo },
    { qr, ski_number: ski.ski_number, brand: ski.brand, type: ski.type, ski_length_cm: ski.ski_length_cm, logo },
  ];
  openPrintWindow(buildLabelsHtml(items, `Ski ${ski.ski_number} - QR Labels`));
} 